import hasClass from './hasClass';
export default function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}


//////////////////
// WEBPACK FOOTER
// ../~/react-transition-group/~/dom-helpers/esm/addClass.js
// module id = 3104
// module chunks = 121